import { render, staticRenderFns } from "./buscarEmisorEntidad.vue?vue&type=template&id=2253db96"
import script from "./buscarEmisorEntidad.vue?vue&type=script&lang=js"
export * from "./buscarEmisorEntidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports